var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.725145 5.39107C0.969223 5.14699 1.36495 5.14699 1.60903 5.39107L4.50042 8.28246L12.3918 0.391065C12.6359 0.146988 13.0316 0.146988 13.2757 0.391065C13.5198 0.635143 13.5198 1.03087 13.2757 1.27495L4.94236 9.60828C4.69828 9.85236 4.30256 9.85236 4.05848 9.60828L0.725145 6.27495C0.481067 6.03087 0.481067 5.63514 0.725145 5.39107Z",
    fill: "#1275C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMenuIcon);
export default __webpack_public_path__ + "static/media/selected-menu-icon.dd03e5391ce9724262159ee179b0c664.svg";
export { ForwardRef as ReactComponent };